"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const classnames_1 = __importDefault(require("classnames"));
const __1 = require("..");
/**
 * Combines multiple fields into one row. Wrapped fields will be displayed one
 * after one with a proper gap in between. On smaller screens they will keep the
 * default, column behavior.
 */
const Row = ({ mobile, noBottomGutter, className = '', children, }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('rfc-row', {
            [classes.row]: !mobile,
            [classes.rowMobile]: mobile,
            [classes.noBottomGutter]: noBottomGutter,
            [className]: className,
        }) }, children));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => {
    const commonStyling = {
        display: 'flex',
        alignItems: 'flex-end',
        marginBottom: theme.sizes.inputGutterBottom,
        '& .rfc-form-control': {
            marginBottom: 0,
        },
        '& > div + *': {
            marginLeft: theme.sizes.rowGutter,
        },
    };
    return {
        row: {
            [(0, __1.breakpoint)(theme.breakpoints.sm)]: commonStyling,
        },
        rowMobile: commonStyling,
        noBottomGutter: {
            marginBottom: 0,
        },
    };
});
exports.default = Row;
